import _ from 'lodash'

export const state = {
  editedSectionIDs: [],
  editedSections: {}
}

export const getters = {
  editedSections(state) {
    return state.editedSectionIDs
  }
}

export const actions = {}

export const mutations = {
  SET_EDITED_SECTIONS(state, payload) {
    _.set(
      state.editedSections,
      [payload.id, payload.tab, payload.key],
      payload.value
    )

    state.editedSections = Object.assign({}, state.editedSections)
  }
}
